<template>
  <div class="recommend-box">
    <div class="top">
      <a href="/">首页</a>
      <span> / </span>
      <span style="font-size: 14px; color: #717171">正文</span>
    </div>
    <!-- 基本信息 -->
    <div class="recommend-content">
      <div class="logo">
        <img
          v-if="orgInfo.coverImg"
          v-lazy="`${$global.imgUrl}${orgInfo.coverImg}`"
          alt
        />
        <img :src="require('@/assets/img/details/jigou.png')" alt="" v-else />
        <span v-if="orgInfo.name">{{ orgInfo.name }}</span>
      </div>
      <div class="msg" v-if="orgInfo.englishName">
        外文名称：
        <span>{{ orgInfo.englishName }}</span>
      </div>
      <div class="msg" v-if="orgInfo.orgBaseType !== 4 && orgInfo.orgBaseType">
        简称：
        <span>{{ orgInfo.abbreviation }}</span>
      </div>
      <!-- 出版单位类型 -->
      <div v-if="orgInfo.orgBaseType === 1">
        <div class="msg">
          地址：<span>{{ orgInfo.address }}</span>
        </div>
        <div class="msg">
          官方网址：<span>{{ orgInfo.website }}</span>
        </div>
      </div>
      <!-- 行业组织类型 -->
      <div v-if="orgInfo.orgBaseType === 2">
        <div class="msg">
          主管部门：<span>{{ orgInfo.company }}</span>
        </div>
        <div class="msg">
          主要成就：<span>{{ orgInfo.achievement }}</span>
        </div>
        <div class="msg">
          登记单位：<span>{{ orgInfo.registrationUnit }}</span>
        </div>
        <div class="msg">
          属性：<span>{{ orgInfo.website }}</span>
        </div>
        <div class="msg">
          地址：<span>{{ orgInfo.address }}</span>
        </div>
      </div>
      <!-- 科研机构类型 -->
      <div v-if="orgInfo.orgBaseType === 3">
        <div class="msg">
          主管部门：<span>{{ orgInfo.company }}</span>
        </div>
        <div class="msg">
          科研地址：<span>{{ orgInfo.address }}</span>
        </div>
        <div class="msg">
          成立时间：<span>{{ orgInfo.establishTime }}</span>
        </div>
      </div>
      <!-- 政府机构类型 -->
      <div v-if="orgInfo.orgBaseType === 4">
        <div class="msg">
          行政级别：<span>{{ orgInfo.type }}</span>
        </div>
        <div class="msg">
          性质：<span>{{ orgInfo.category }}</span>
        </div>
        <div class="msg">
          成立时间：<span>{{ orgInfo.establishTime }}</span>
        </div>
        <div class="msg">
          办公地址：<span>{{ orgInfo.address }}</span>
        </div>
      </div>
      <!-- 院校类型 -->
      <div v-if="orgInfo.orgBaseType === 5">
        <div class="msg">
          主管部门：<span>{{ orgInfo.company }}</span>
        </div>
        <div class="msg">
          创办时间：<span>{{ orgInfo.establishTime }}</span>
        </div>
        <div class="msg">
          地址：<span>{{ orgInfo.address }}</span>
        </div>
        <div class="msg">
          创办人：<span>{{ orgAcademy.founder }}</span>
        </div>
        <div class="msg">
          办学性质：<span>{{ orgAcademy.category }}</span>
        </div>
        <div class="msg">
          学校类别：<span>{{ orgAcademy.schoolType }}</span>
        </div>
        <div class="msg">
          学校特色：<span>{{ orgAcademy.schoolFeature }}</span>
        </div>
        <div class="msg">
          所属企业：<span>{{ orgAcademy.affiliatedEnterprise }}</span>
        </div>
        <div class="msg">
          现任领导：<span>{{ orgAcademy.currentLeader }}</span>
        </div>
        <div class="msg">
          专职院士数：<span>{{ orgAcademy.academician }}</span>
        </div>
        <div class="msg">
          高职专业：<span>{{ orgAcademy.higherVocationalProfession }}</span>
        </div>
        <div class="msg">
          本科专业：<span>{{ orgAcademy.undergraduateMajor }}</span>
        </div>
        <div class="msg">
          硕士点：<span>{{ orgAcademy.master }}</span>
        </div>
        <div class="msg">
          博士点：<span>{{ orgAcademy.doctor }}</span>
        </div>
        <div class="msg">
          博士后：<span>{{ orgAcademy.postdoctor }}</span>
        </div>
        <div class="msg">
          国家重点学科：<span>{{ orgAcademy.coreSubject }}</span>
        </div>
        <div class="msg">
          院系设置：<span>{{ orgAcademy.faculty }}</span>
        </div>
        <div class="msg">
          校训：<span>{{ orgAcademy.motto }}</span>
        </div>
        <div class="msg">
          校歌：<span>{{ orgAcademy.schoolSong }}</span>
        </div>
        <div class="msg">
          校庆日：<span>{{ orgAcademy.schoolDay }}</span>
        </div>
        <div class="msg">
          院训：<span>{{ orgAcademy.collegeMotto }}</span>
        </div>
        <div class="msg">
          院歌：<span>{{ orgAcademy.courtyardSong }}</span>
        </div>
        <div class="msg">
          院庆日：<span>{{ orgAcademy.collegeDay }}</span>
        </div>
        <div class="msg">
          院校代码：<span>{{ orgAcademy.schoolCode }}</span>
        </div>
        <div class="msg">
          主要奖项：<span>{{ orgAcademy.majorAwards }}</span>
        </div>
        <div class="msg">
          知名校友：<span>{{ orgAcademy.famousAlumni }}</span>
        </div>
        <div class="msg">
          知名教师：<span>{{ orgAcademy.famousTeachers }}</span>
        </div>
      </div>
      <!-- 其他类型 -->
      <div v-if="orgInfo.orgBaseType === 6"></div>
      <!-- 分享按钮 -->
      <div class="msg" v-if="orgInfo.outline">
        机构概述：
        <span>{{ orgInfo.outline }}</span>
      </div>
      <ul class="icon">
        <!-- <li @click.stop="collect()">
          <img v-if="isCollect" src="@/assets/img/qietu/sc.png" alt="" />
          <img v-else src="@/assets/img/qietu/kongxin.png" alt="" />
          <span>收藏</span>
        </li> -->
        <li class="share">
          <img src="@/assets/img/qietu/share.png" alt="" />
          <div>分享</div>
          <ul class="share_box">
            <div class="sanjiao"></div>
            <li @mouseover.stop="weChat" class="weChat">
              <img src="@/assets/img/details/WeChat.png" alt="" />
              <div>微信</div>
              <div id="WXqrcode" ref="WXqrcode" class="ma"></div>
            </li>
            <li @click.stop="weibo">
              <img src="@/assets/img/details/weiBo.png" alt="" />
              <div>新浪微博</div>
            </li>
            <li @mouseover.stop="qq" class="qq">
              <img src="@/assets/img/details/QQ.png" alt="" />
              <div>QQ</div>
              <div id="QQqrcode" ref="QQqrcode" class="ma"></div>
            </li>
            <li @click.stop="space">
              <img src="@/assets/img/details/qqspace.png" alt="" />
              <div>QQ空间</div>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <div class="recommend-content">
      <Book :orgPeriodical="orgPeriodical" />
    </div>
    <div class="recommend-content">
      <p class="title">机构学者</p>
      <User v-if="orgUser.length > 0" :orgUser="orgUser" />
      <div class="empty" v-else>暂无学者</div>
    </div>
    <!-- 会议列表 -->
    <div class="recommend-content">
      <Meet />
    </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import Book from "./components/book";
import User from "./components/user";
import Meet from "./components/meet";
import { mapState } from "vuex";
export default {
  components: {
    Book,
    User,
    Meet,
  },
  data() {
    return {
      orgInfo: {},
      orgAcademy: {},
      orgPeriodical: {},
      orgUser: [],
      isCollect: false,
      WXurl: "",
      QQurl: "",
    };
  },
  created() {
    this.getData({ orgId: this.$route.query.id });
  },
  computed: {
    ...mapState(["hasLogin"]),
  },
  methods: {
    weChat() {
      if (this.WXurl !== "") return;
      this.WXurl =
        this.$global.url1 +
        `appusesinstitutions?type=2&orgId=${this.$route.query.id}`;
      // 使用$nextTick确保数据渲染
      this.$nextTick(() => {
        this.WXcrateQrcode();
      });
    },
    qq() {
      if (this.QQurl !== "") return;
      this.QQurl =
        this.$global.url1 +
        `appusesinstitutions?type=2&orgId=${this.$route.query.id}`;
      // 使用$nextTick确保数据渲染
      this.$nextTick(() => {
        this.QQcrateQrcode();
      });
    },
    WXcrateQrcode() {
      this.qr = new QRCode("WXqrcode", {
        width: 150,
        height: 150, // 高度
        text: this.WXurl, // 二维码内容
      });
    },
    QQcrateQrcode() {
      this.qr = new ("QQqrcode",
      {
        width: 150,
        height: 150, // 高度
        text: this.QQurl, // 二维码内容
      })();
    },
    weibo() {
      let url = encodeURIComponent(
        this.$global.url1 + `recommend?id=${this.$route.query.id}`
      );
      let srcUrl = "";
      this.orgInfo.coverImg
        ? (srcUrl = `pic=${this.$global.imgUrl + this.orgInfo.coverImg}&`)
        : (srcUrl = "");
      window.open(
        `https://service.weibo.com/share/share.php?${srcUrl}url=${url}&title=${this.orgInfo.name}`
      );
    },
    space() {
      let url = encodeURIComponent(
        this.$global.url1 + `recommend?id=${this.$route.query.id}`
      );
      let srcUrl = "";
      this.orgInfo.coverImg
        ? (srcUrl = `pics=${this.$global.imgUrl + this.orgInfo.coverImg}&`)
        : (srcUrl = "");
      window.open(
        `https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?${srcUrl}url=${url}&title=${this.orgInfo.name}`
      );
    },
    async getData(obj) {
      const res = await this.$apis.recomendServe.getRecomendList(obj);
      document.title = res.orgInfo.name + " - 中文知识网";
      this.orgInfo = res.orgInfo; // 名录基本信息
      this.orgUser = [...res.orgUser]; // 名录机构学者
      this.orgAcademy = res.orgInfo.orgAcademy ? res.orgInfo.orgAcademy : {};
      this.orgPeriodical = res.orgPeriodical;
    },
  },
};
</script>

<style lang="scss" scoped>
.recommend-box {
  width: 100%;
  .top {
    margin-left: 7px;
    margin-bottom: 20px;
    font-size: 18px;
    a {
      color: #464646;
    }
  }
  .recommend-content {
    overflow: hidden;
    margin-bottom: 20px;
    padding: 30px;
    width: 100%;
    border: 1px solid #a3cbe7;
    border-radius: 10px;
    .title {
      font-size: 22px;
      color: #1d52eb;
    }
    .empty {
      padding: 60px 0;
      text-align: center;
      font-size: 16px;
      color: #666666;
    }
    .logo {
      display: flex;
      align-items: center;
      margin-bottom: 25px;
      img {
        width: 84px;
        height: 84px;
        border-radius: 50%;
      }
      span {
        margin-left: 7px;
        font-size: 22px;
        color: #263d78;
      }
    }
    .msg {
      font-size: 14px;
      color: #333333;
      line-height: 28px;
    }
    .icon {
      display: flex;
      margin-top: 50px;
      height: 37px;
      background: #ffffff;
      li {
        border: 1px solid #dfe8f2;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        padding: 10px;
        box-sizing: border-box;
        cursor: pointer;
        &:not(:last-child) {
          border-right: none;
        }
        img {
          width: 20px;
          height: 20px;
          margin-right: 6px;
        }
      }
      .share:hover {
        .share_box {
          display: block;
        }
      }
      .share {
        position: relative;
        .share_box {
          cursor: pointer;
          display: none;
          right: -133px;
          top: -130px;
          position: absolute;
          width: 133px;
          height: 167px;
          background: #ffffff;
          box-shadow: 3px 1px 7px 0px rgba(8, 8, 64, 0.23);
          border-radius: 10px;
          .weChat:hover {
            .ma {
              display: flex;
              justify-content: center;
              align-items: center;
              z-index: 99;
            }
          }

          .weChat {
            position: relative;
            .ma {
              display: none;
              left: 123px !important;
              position: absolute !important;
              width: 200px !important;
              top: -10px !important;
              height: 167px !important;
              background: white !important;
              box-shadow: 3px 1px 7px 0px rgba(8, 8, 64, 0.23);
              border-radius: 10px;
            }
          }
          .qq:hover {
            .ma {
              display: flex;
              justify-content: center;
              align-items: center;
            }
          }
          .qq {
            position: relative;
            .ma {
              display: none;
              left: 123px !important;
              position: absolute !important;
              width: 200px !important;
              top: -90px !important;
              height: 167px !important;
              background: white !important;
              box-shadow: 3px 1px 7px 0px rgba(8, 8, 64, 0.23);
              border-radius: 10px;
            }
          }
          li {
            border: none;
            margin-top: 10px;
            margin-bottom: 0px;
            //display: flex;
            flex-wrap: nowrap;
            //background: pink;
            justify-content: center;
            align-items: center;
            width: 133px;
            height: 30px;

            div {
              width: 60px;
              //background: yellow;
              margin-left: 10px;
            }
            img {
              width: 20px;
              height: 20px;
            }
          }
          .sanjiao {
            width: 0;
            height: 0;
            border-top: 3px solid transparent;
            border-right: 6px solid #fff;
            position: absolute;
            top: 50%;
            margin-top: -3px;
            left: -6px;
            border-bottom: 3px solid transparent;

            //background: pink;
          }
        }
      }
    }
  }
}
</style>
